import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

//components
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { Button } from "components/DesignSystem/Button/Button";
import { CaretDown } from "components/icons/CaretDown";
import { Check } from "components/icons/Check";

//api
import { getCompanyGroups } from "../../../apis/getCompanyGroups";
import { putSwitchGroup } from "../../../apis/putSwitchGroup";
import { useSelector } from "react-redux";

export default function GroupSelect() {
  const [groups, setGroups] = useState([]);
  const { dashboardSidebarExpand, isCollapsedSidebarHovered } = useSelector(
    (state) => state.dashboard
  );

  useEffect(() => {
    getCompanyGroups()
      .then((res) => {
        setGroups(res.data.data.company_groups);
      })
      .catch((err) => {});
  }, []);

  function switchGroup(uuid) {
    putSwitchGroup({ uuid }).then(() => {
      window.location.reload();
    });
  }

  const activeGroup = groups?.[0];

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <button
          type="button"
          className="t-w-full t-flex t-items-center t-justify-between t-gap-2 t-rounded-lg t-border t-border-solid t-border-neutral-10 t-bg-surface t-px-3 t-py-2 t-outline-none hover:t-bg-surface-lighter-grey t-cursor-pointer t-transition-colors"
        >
          <div className="t-flex t-flex-col t-items-start t-min-w-0">
            <span className="t-text-body-sm t-font-medium t-text-text-100 t-truncate t-max-w-full">
              {activeGroup?.name}
            </span>
            <span className="t-text-subtext-sm t-text-text-30">Group</span>
          </div>
          <span className="t-text-text-30 t-shrink-0">
            <CaretDown />
          </span>
        </button>
      </Dropdown.Trigger>

      <Dropdown.Portal>
        <Dropdown.Content align="start" sideOffset={6} className="t-w-56">
          {groups?.map((group) => {
            const isActive = group.uuid === activeGroup?.uuid;
            return (
              <Dropdown.Item
                key={group.uuid}
                onSelect={() => !isActive && switchGroup(group.uuid)}
                icon={
                  <span
                    className={classNames("t-w-4 t-h-4 t-flex t-items-center", {
                      "t-text-purple-50": isActive,
                      "t-invisible": !isActive,
                    })}
                  >
                    <Check />
                  </span>
                }
                className={classNames({
                  "t-text-purple-50 t-font-medium": isActive,
                })}
              >
                <span className="t-truncate">{group.name}</span>
              </Dropdown.Item>
            );
          })}

          <Dropdown.Separator />

          <div className="t-px-2 t-py-1.5">
            <Link to="/profile" className="t-no-underline t-block">
              <Button customType="primary" size="small" block>
                Create new group
              </Button>
            </Link>
          </div>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
}
